import { ComponentPropsWithoutRef } from 'react';

import {
  Tooltip,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

import { useEvaluationContextField } from '@spotify/plugin-confidence-targeting-react';

import { Expression } from '../Expression';

const styles = createStyles({
  root: {},
  addedText: {
    color: 'var(--bui-fg-success)',
  },
  removedText: {
    color: 'var(--bui-fg-secondary)',
    textDecoration: 'line-through',
  },
  modifiedText: {},
});

interface DeltaFieldNameProps
  extends Omit<ComponentPropsWithoutRef<typeof Expression.Property>, 'classes'>,
    WithStyles<typeof styles> {
  field: string;
  change?: 'added' | 'removed';
}

const DeltaFieldName = ({
  field,
  className,
  change,
  classes,
  ...rest
}: DeltaFieldNameProps) => {
  const fieldOverride = useEvaluationContextField(field);

  return (
    <Tooltip title={field} arrow enterDelay={700}>
      <Expression.Property
        className={classNames(
          classes.root,
          className,
          change === 'added' && classes.addedText,
          change === 'removed' && classes.removedText,
        )}
        {...rest}
      >
        {fieldOverride?.displayName || field}
      </Expression.Property>
    </Tooltip>
  );
};

export default withStyles(styles)(DeltaFieldName);
